export var PregnancyWellBeingStatus;
(function (PregnancyWellBeingStatus) {
    PregnancyWellBeingStatus["BadTemper"] = "badTemper";
    PregnancyWellBeingStatus["Moody"] = "moody";
    PregnancyWellBeingStatus["Fluctuating"] = "fluctuating";
    PregnancyWellBeingStatus["Calm"] = "calm";
    PregnancyWellBeingStatus["Cheerful"] = "cheerful";
})(PregnancyWellBeingStatus || (PregnancyWellBeingStatus = {}));
export var PregnancySymptom;
(function (PregnancySymptom) {
    PregnancySymptom["NoSymptom"] = "noSymptom";
    PregnancySymptom["FatigueExhaustion"] = "fatigueExhaustion";
    PregnancySymptom["MorningNausea"] = "morningNausea";
    PregnancySymptom["ShortnessOfBreath"] = "shortnessOfBreath";
    PregnancySymptom["ColdFluSymptoms"] = "coldFluSymptoms";
    PregnancySymptom["PullingSensation"] = "pullingSensation";
    PregnancySymptom["Headache"] = "headache";
    PregnancySymptom["Acne"] = "acne";
    PregnancySymptom["Dizziness"] = "dizziness";
    PregnancySymptom["VisionChanges"] = "visionChanges";
    PregnancySymptom["NeckPain"] = "neckPain";
    PregnancySymptom["GumNoseBleeding"] = "gumNoseBleeding";
    PregnancySymptom["SensitiveBreasts"] = "sensitiveBreasts";
    PregnancySymptom["BackPain"] = "backPain";
    PregnancySymptom["ChestPain"] = "chestPain";
    PregnancySymptom["Heartburn"] = "heartburn";
    PregnancySymptom["SoreNipples"] = "soreNipples";
    PregnancySymptom["SwollenBreasts"] = "swollenBreasts";
    PregnancySymptom["Bloating"] = "bloating";
    PregnancySymptom["AbdominalPain"] = "abdominalPain";
    PregnancySymptom["StomachPain"] = "stomachPain";
    PregnancySymptom["Constipation"] = "constipation";
    PregnancySymptom["IncreasedAppetite"] = "increasedAppetite";
    PregnancySymptom["DecreasedAppetite"] = "decreasedAppetite";
    PregnancySymptom["Cravings"] = "cravings";
    PregnancySymptom["Aversion"] = "aversion";
    PregnancySymptom["Diarrhea"] = "diarrhea";
    PregnancySymptom["Vomiting"] = "vomiting";
    PregnancySymptom["AbdominalItching"] = "abdominalItching";
    PregnancySymptom["BowelMovement"] = "bowelMovement";
    PregnancySymptom["NoBowelMovement"] = "noBowelMovement";
    PregnancySymptom["IncreasedThirst"] = "increasedThirst";
    PregnancySymptom["FrequentUrination"] = "frequentUrination";
    PregnancySymptom["RareUrination"] = "rareUrination";
    PregnancySymptom["VaginalBleeding"] = "vaginalBleeding";
    PregnancySymptom["HeavyVaginalBleeding"] = "heavyVaginalBleeding";
    PregnancySymptom["PelvicDiscomfortPressure"] = "pelvicDiscomfortPressure";
    PregnancySymptom["ContractionsBraxtonHicks"] = "contractionsBraxtonHicks";
    PregnancySymptom["VaginalIrritation"] = "vaginalIrritation";
    PregnancySymptom["AlteredVaginalDischarge"] = "alteredVaginalDischarge";
    PregnancySymptom["LegCramps"] = "legCramps";
    PregnancySymptom["JointPain"] = "jointPain";
    PregnancySymptom["Swelling"] = "swelling";
    PregnancySymptom["VividDreams"] = "vividDreams";
    PregnancySymptom["IncreasedSexualDesire"] = "increasedSexualDesire";
    PregnancySymptom["DecreasedSexualDesire"] = "decreasedSexualDesire";
    PregnancySymptom["Insomnia"] = "insomnia";
    PregnancySymptom["RestlessSleep"] = "restlessSleep";
})(PregnancySymptom || (PregnancySymptom = {}));
export var PregnancyStatus;
(function (PregnancyStatus) {
    PregnancyStatus["NotBorn"] = "notBorn";
    PregnancyStatus["Born"] = "born";
    PregnancyStatus["Miscarriage"] = "miscarriage";
})(PregnancyStatus || (PregnancyStatus = {}));
export const PRENATAL_TESTING_METHOD_FOR_HUMANS = {
    ultrasound: "Ultrahang vizsgálat",
    genetic: "Genetikai vizsgálat",
};
export const WELL_BEING_STATUS_FOR_HUMANS = {
    [PregnancyWellBeingStatus.BadTemper]: "Rosszkedvű",
    [PregnancyWellBeingStatus.Moody]: "Kedvetlen",
    [PregnancyWellBeingStatus.Fluctuating]: "Hullámzó",
    [PregnancyWellBeingStatus.Calm]: "Nyugodt",
    [PregnancyWellBeingStatus.Cheerful]: "Derűs",
};
export const PREGNANCY_SYMPTOMS_FOR_HUMANS = {
    [PregnancySymptom.NoSymptom]: "Nincs tünet",
    [PregnancySymptom.FatigueExhaustion]: "Fáradtság/kimerültség",
    [PregnancySymptom.MorningNausea]: "Reggeli rosszullét / hányinger",
    [PregnancySymptom.ShortnessOfBreath]: "Légszomj",
    [PregnancySymptom.ColdFluSymptoms]: "Megfázás / influenza tünetei",
    [PregnancySymptom.PullingSensation]: "Húzódó érzés",
    [PregnancySymptom.Headache]: "Fejfájás",
    [PregnancySymptom.Acne]: "Pattanások",
    [PregnancySymptom.Dizziness]: "Szédülés",
    [PregnancySymptom.VisionChanges]: "Látásváltozás",
    [PregnancySymptom.NeckPain]: "Nyaki fájdalmak",
    [PregnancySymptom.GumNoseBleeding]: "Fogínyvérzés / orrvérzés",
    [PregnancySymptom.SensitiveBreasts]: "Érzékeny mellek",
    [PregnancySymptom.BackPain]: "Hátfájás",
    [PregnancySymptom.ChestPain]: "Mellfájdalom",
    [PregnancySymptom.Heartburn]: "Gyomorégés",
    [PregnancySymptom.SoreNipples]: "Fájó mellbimbó",
    [PregnancySymptom.SwollenBreasts]: "Mellek duzzadása",
    [PregnancySymptom.Bloating]: "Puffadás",
    [PregnancySymptom.AbdominalPain]: "Hasi fájdalmak",
    [PregnancySymptom.StomachPain]: "Gyomorfájás",
    [PregnancySymptom.Constipation]: "Székrekedés",
    [PregnancySymptom.IncreasedAppetite]: "Étvágynövekedés",
    [PregnancySymptom.DecreasedAppetite]: "Étvágycsökkenés",
    [PregnancySymptom.Cravings]: "Vágyakozás",
    [PregnancySymptom.Aversion]: "Averzió",
    [PregnancySymptom.Diarrhea]: "Hasmenés",
    [PregnancySymptom.Vomiting]: "Hányás",
    [PregnancySymptom.AbdominalItching]: "Hasi viszketés",
    [PregnancySymptom.BowelMovement]: "Bélmozgás",
    [PregnancySymptom.NoBowelMovement]: "Nincs székletürítés",
    [PregnancySymptom.IncreasedThirst]: "Fokozott szomjúság",
    [PregnancySymptom.FrequentUrination]: "Gyakori vizelés",
    [PregnancySymptom.RareUrination]: "Ritkán vizelés",
    [PregnancySymptom.VaginalBleeding]: "Hüvelyi vérzés / vérzés",
    [PregnancySymptom.HeavyVaginalBleeding]: "Erős hüvelyi vérzés",
    [PregnancySymptom.PelvicDiscomfortPressure]: "Kismedencei kellemetlenség és nyomás",
    [PregnancySymptom.ContractionsBraxtonHicks]: "Összehúzódások (Braxton Hicks)",
    [PregnancySymptom.VaginalIrritation]: "Hüvelyi irritáció",
    [PregnancySymptom.AlteredVaginalDischarge]: "Megváltozott hüvelyi folyás",
    [PregnancySymptom.LegCramps]: "Lábgörcsök",
    [PregnancySymptom.JointPain]: "Ízületi fájdalom",
    [PregnancySymptom.Swelling]: "Duzzanat",
    [PregnancySymptom.VividDreams]: "Élénk álmok",
    [PregnancySymptom.IncreasedSexualDesire]: "Növekvő szexuális vágy",
    [PregnancySymptom.DecreasedSexualDesire]: "Csökkenő szexuális vágy",
    [PregnancySymptom.Insomnia]: "Álmatlanság",
    [PregnancySymptom.RestlessSleep]: "Nyugtalan alvás",
};
